import { ogImage, OG_SIZE } from "@/lib/og";

export const alt = "AI Agents by Industry — Quto AI";
export const size = OG_SIZE;
export const contentType = "image/png";

export default function Image() {
  return ogImage({
    title: "AI Agents by Industry",
    eyebrow: "Healthcare · Automobile · Real Estate",
  });
}
